import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { isDesktop } from "react-device-detect";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";

import SupportCodeService from "../../../services/SupportCodeService";

class SupportCode extends Component {
    state = { code: "", loading: true, rotating: false };

    componentDidMount() {
        this.mounted = true;
        window.addEventListener("support-code-updated", this.handleCodeUpdated);
        this.loadCode();
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("support-code-updated", this.handleCodeUpdated);
    }

    handleCodeUpdated = (event) => {
        if (this.mounted && event.detail) {
            this.setState({ code: event.detail });
        }
    };

    loadCode = () => {
        SupportCodeService.getCurrentCode()
            .then((code) => {
                if (this.mounted) {
                    this.setState({ code, loading: false });
                }
            })
            .catch(() => {
                if (this.mounted) this.setState({ loading: false });
            });
    };

    copyCode = async () => {
        const { code } = this.state;
        const { t } = this.props;
        if (!code) return;

        try {
            await SupportCodeService.copyToClipboard(code);

            Swal.fire({
                iconHtml: !isDesktop ? '<img src="https://api.iconify.design/mdi:check.svg?color=%23ffffff">' : "",
                title: t("global.success"),
                text: t("profile.support-code-copied"),
                icon: "success",
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop ? {
                    container: "swal-mobile-container sucess",
                    icon: "swal-success-icon",
                } : [],
            });
        } catch (error) {
            Swal.fire({
                title: t("global.error"),
                text: t("profile.support-code-copy-failed"),
                icon: "error",
                confirmButtonText: t("global.ok"),
            });
        }
    };

    rotateCode = () => {
        const { t } = this.props;

        Swal.fire({
            title: t("profile.rotate-support-code"),
            text: t("profile.rotate-support-code-desc"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("profile.rotate"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (!result.isConfirmed || !this.mounted) return;

            this.setState({ rotating: true });
            SupportCodeService.rotate()
                .then((code) => {
                    if (this.mounted) {
                        this.setState({ code, rotating: false });
                        Swal.fire({
                            title: t("global.success"),
                            text: t("profile.support-code-rotated"),
                            icon: "success",
                            confirmButtonText: t("global.ok"),
                        });
                    }
                })
                .catch(() => {
                    if (this.mounted) this.setState({ rotating: false });
                });
        });
    };

    renderContent() {
        const { t } = this.props;
        const { code, loading, rotating } = this.state;
        if (loading) return <Skeleton count={1} width={240} />;

        return (
            <>
                <div className="support-code-value" aria-live="polite">
                    {code || t("profile.support-code-unavailable")}
                </div>
                <div className="support-code-actions">
                    <button className="btn btn-gradient-blue" type="button" onClick={this.copyCode} disabled={!code || rotating}>
                        {t("profile.copy-support-code")}
                    </button>
                    <button className="btn btn-outline-red" type="button" onClick={this.rotateCode} disabled={rotating}>
                        {rotating ? t("profile.rotating") : t("profile.rotate")}
                    </button>
                </div>
            </>
        );
    }

    render() {
        const { mobile, t } = this.props;

        if (mobile) {
            return (
                <div className="input-group-col support-code-mobile">
                    <label className="col-form-label">{t("profile.support-code")}</label>
                    <div className="support-code-content">{this.renderContent()}</div>
                    <small>{t("profile.support-code-desc")}</small>
                </div>
            );
        }

        return (
            <div className="row support-code-row">
                <label className="col-3 col-form-label">{t("profile.support-code")}:</label>
                <div className="col-9">
                    <div className="support-code-content">{this.renderContent()}</div>
                    <small>{t("profile.support-code-desc")}</small>
                </div>
            </div>
        );
    }
}

export default withNamespaces("translation")(SupportCode);
